import Base from './Base';

class Notifications extends Base {
    get(query = null, page = null, count = null, opts = null) {
        return this.getJSONWithSession<ApiListResponse<Notification>>(
            '/notifications',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        );
    }

    new(query = null, opts = null) {
        return this.getJSONWithSession<Notification[]>('/notifications/new', query, opts);
    }

    markAsRead(id, opts = null) {
        return this.postJSONWithSession(`/notifications/${id}/read`, {}, opts);
    }
}

export default Notifications;
